import React from 'react'

export default class Dropdown extends React.Component {

	handleChange(e) {
		if (this.props.onSelectChange) {
			const change = {
				name: this.props.name,
				newValue: e.target.value
			}
			this.props.onSelectChange(change)
		}
	}

	render() {
		const options = this.props.options.map((option) => {
			return (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			)
		})
		const disabled = (this.props.disabled === undefined) ? false : this.props.disabled
		const extraClass = (this.props.extraClass === undefined) ? 'lpa-input dropdown' : 'lpa-input dropdown ' + this.props.extraClass
		return (
			<div>
				<select
					className={extraClass}
					disabled={disabled}
					onChange={(e) => this.handleChange(e)}
					name={this.props.name}
					value={this.props.value}
				>
					{options}
				</select>
			</div>
		)
	}

}